<template>
    <v-card>
        <v-card-text>
            <v-sheet tile height="6vh" class="d-flex justify-space-between align-center jusst">
                <v-btn icon @click="$refs.calendar.prev()">
                    <v-icon>mdi-chevron-left</v-icon> {{ prev }}
                </v-btn>
                <!-- <v-btn small class="primary ma-4" @click="setToday">
                    {{ nowBtnTitle }}
                </v-btn> -->
                <v-card-title>{{ title }}</v-card-title>

                <v-btn icon @click="$refs.calendar.next()">
                    {{ next }} <v-icon>mdi-chevron-right</v-icon>
                </v-btn>

                <!-- <v-btn @click="toMonth" v-if="type == 'category'">
                    月別へ
                </v-btn> -->


            </v-sheet>
            <div class="d-flex justify-space-between align-center info-search">
                <div>
                    <v-data-table :headers="headerCount" :items="countBlindDate" :disable-sort="true"
                    :server-items-length="countBlindDate.length" hide-default-footer hide-default-header dense
                    class="fluid-table others elevation-1 table-count">
                    <template v-slot:header>
                        <tr>
                        <th v-for="header in headerCount" :key="header.value"
                            :class="'pa-1 text-no-wrap text-body-2 font-weight-medium invalid ' + (header.value === 'name' ? 'head-col' : '') + (countBlindDate.length === 0 ? ' no-data' : '')">
                            {{ header.text }}
                        </th>
                        </tr>
                    </template>
                    <template v-slot:body="{ items }">
                        <tr v-for="item in items" :key="item.id">
                        <td class="head-col text-caption pa-1" :title="item.name">
                            <div class="text-truncate text-center w-100">{{ item.name }}</div>
                        </td>
                        <td v-for="(el, index) in headerCount.slice(1)" :key="index" class=""
                            :style="{ width: el.value !== '19:00:00' ? 'calc((84vw - 110px) * 3 / 11)' : 'calc((84vw - 110px) * 2 / 11)', verticalAlign: 'top', textAlign: 'center' }">
                            <div>
                            <span>{{ item[el.value] }}</span>
                            </div>
                        </td>
                        </tr>
                        <tbody v-if="countBlindDate.length === 0">
                        <tr>
                            <td colspan="12" style="color: rgba(0, 0, 0, 0.38)">記録はありません</td>
                        </tr>
                        </tbody>
                    </template>
                    </v-data-table>
                </div>
                <div>
                    <v-btn @click="toMonth" v-if="type == 'category'">
                        月別へ
                    </v-btn>
                </div>
                <div class="d-flex">
                    <v-checkbox v-model="filter_kind.all" @click="changeShop" label="全て" class="mr-16"></v-checkbox>
                    <v-checkbox v-model="filter_kind.matching" @click="changeShop" label="お見合い"
                        class="mr-16"></v-checkbox>
                    <v-checkbox v-model="filter_kind.counseling" @click="changeShop" label="カウンセリング"
                        class="mr-16"></v-checkbox>
                    <v-checkbox v-model="filter_kind.own_schedule" @click="changeShop" label="自分予定のみ"
                        class="mr-16"></v-checkbox>
                </div>
                <div>
                    <v-select v-model="shop_id" :items="shops" label="支店" @change="changeShop"
                        style="min-width: min-content;"></v-select>
                </div>
            </div>
            <v-sheet>
                <v-calendar ref="calendar" v-model="value" :type="type" category-show-all :categories="counselors"
                    :events="events" event-category="category" category-text="text" :event-more="false"
                    :event-color="getEventColor" :day-format="(timestamp) => new Date(timestamp.date).getDate()"
                    :month-format="(timestamp) => new Date(timestamp.date).getMonth() + 1 + ' /'" interval-height="96"
                    first-interval="9" interval-count="13" @change="getEvents" @click:event="showEvent"
                    @click:date="toDay">
                    <template v-slot:day="{ date, month }">
                        <template>
                            <div class="text-center items" v-if="month == getMonth()">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="info" dark x-small v-bind="attrs" v-on="on" active="true">
                                            +
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <p ref="pCloseMenu" hidden></p>
                                        <CompanyVisit :date="date" :boothNos="boothNos" :counselors="counselorsForForm"
                                            :shop_id="shop_id" @refreshCalendar="refreshCalendar"
                                            @closeMenu="closeMenu" :isOnlineShop="isOnlineShop" />
                                        <InHouseMatchmaking :date="date" :boothNos="boothNos" :shop_id="shop_id"
                                            :counselors="counselorsForForm" @refreshCalendar="refreshCalendar"
                                            @closeMenu="closeMenu" :isOnlineShop="isOnlineShop" />
                                        <PartnerSelection :date="date" :boothNos="boothNos"
                                            :counselors="counselorsForForm" :shop_id="shop_id"
                                            @refreshCalendar="refreshCalendar" @closeMenu="closeMenu" :isOnlineShop="isOnlineShop" />
                                        <ConnectMatchmaking :date="date" :boothNos="boothNos" :shop_id="shop_id"
                                            :counselors="counselorsForForm" @refreshCalendar="refreshCalendar"
                                            @closeMenu="closeMenu" :isOnlineShop="isOnlineShop" />
                                        <DateMatchmaking :date="date" :boothNos="boothNos"
                                            :counselors="counselorsForForm" :shop_id="shop_id"
                                            @refreshCalendar="refreshCalendar" @closeMenu="closeMenu" />
                                        <OtherHistoryTable :date="date" :boothNos="boothNos"
                                            :counselors="counselorMasters" :shop_id="shop_id"
                                            @refreshCalendar="refreshCalendar" @closeMenu="closeMenu" />
                                    </v-list>
                                </v-menu>
                            </div>
                        </template>
                    </template>
                    <template v-slot:event="props">
                        <div class="pl-1" :style="props.event.is_online ? 'color: black;' : ''">
                            <div v-if="props.event.timed && type == 'category'">
                                {{ props.eventParsed.start.time }} - {{ props.eventParsed.end.time }}<br />
                                {{ props.event.is_online ? 'On ' : '' }}{{ props.event.name }} {{ getEventKindName(props.event) }}<br />
                                {{ props.event.note }}
                            </div>
                            <div v-else-if="props.event.timed && type == 'month'">
                                {{ props.eventParsed.start.time }}
                                <span v-if="props.event.kind != CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.WOMAN_FIRST && props.event.kind != CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.ADVISE">{{ props.event.is_online ? 'On ' : '' }}{{ props.event.name }}</span>
                                {{ getEventKindName(props.event) }}
                            </div>
                            <div v-else>
                                {{ props.event.is_online ? 'On ' : '' }}{{ props.event.name }} {{ getEventKindName(props.event) }}
                            </div>
                        </div>
                    </template>
                </v-calendar>
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-y>
                    <v-card color="grey lighten-4" min-width="350px" flat>
                        <v-toolbar :color="selectedEvent.color" dark>
                            <v-toolbar-title>{{ getEventKindName(selectedEvent) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn light fab small
                                :to="`customer/history/${selectedEvent.customer_id}?id=${selectedEvent.id}`"
                                target="_blank">
                                経緯表
                            </v-btn>
                            <v-btn icon @click="selectedOpen = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <div v-if="selectedEvent.timed">
                                {{ moment(selectedEvent.start).format("HH:mm") }}-{{ selectedEvent.end ?
                    moment(selectedEvent.end).format("HH:mm") : "-" }}
                            </div>
                            <div>
                                <span v-if="selectedEvent.kind != CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.WOMAN_FIRST && selectedEvent.kind != CUSTOMER.KINDS_FOR_COMPANY_VISIT.VAL.ADVISE">{{ selectedEvent.name }}</span>
                                担当CO：{{ selectedEvent.category }}<br>
                                <span style="white-space:pre-wrap; word-wrap:break-word;">{{ selectedEvent.note
                                    }}</span>
                            </div>
                            <span v-html="selectedEvent.details"></span>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </v-sheet>
        </v-card-text>
    </v-card>
</template>

<script>
import CUSTOMER from "@/consts/customer.js";
import moment from "moment";
import CompanyVisit from "@/components/CompanyVisit";
import InHouseMatchmaking from "@/components/InHouseMatchmaking";
import PartnerSelection from "@/components/PartnerSelection";
import ConnectMatchmaking from "@/components/ConnectMatchmaking";
import DateMatchmaking from "@/components/DateMatchmaking";
import OtherHistoryTable from "@/components/OtherHistoryTable";
import store from "@/store";

export default {
    title: "Top",
    name: "top",
    components: {
        CompanyVisit,
        InHouseMatchmaking,
        PartnerSelection,
        ConnectMatchmaking,
        DateMatchmaking,
        OtherHistoryTable,
    },

    data: () => ({
        filter_kind: {
            all: false,
            matching: false,
            counseling: false,
            own_schedule: false,
        },

        CUSTOMER: CUSTOMER,
        events: [],
        counselors: [],
        value: moment().format("yyyy-MM-DD"),
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        now: null,
        type: "month",
        shop_id: 1,
        shops: null,
        moment: moment,
        counselorMasters: [],
        counselorsForForm: [],
        boothNoMasters: [],
        boothNos: [],
        prev: '前月',
        next: '次月',
        headerCount: [
            { text: '', value: 'name' },
            { text: '予定', value: '1' },
            { text: '実施', value: '2' },
            { text: '合計（不履行）', value: '3' },
        ],
        countBlindDate: [
            {
                name: '自社見合い',
                type: 'note',
                '1': 0,
                '2': 0,
                '3': 0,
            },
            {
                name: '連盟見合',
                type: 'note',
                '1': 0,
                '2': 0,
                '3': 0,
            },
            {
                name: '他支店見合い',
                type: 'note',
                '1': 0,
                '2': 0,
                '3': 0,
            }
        ]
    }),
    created() {
        this.getCO(0);
        this.getBoothNo();
    },
    computed: {
        title() {
            return moment(this.value).format("yyyy年MM月");
        },
        nowBtnTitle() {
            return (this.type == 'month') ? "当月" : "今日";
        },
        isOnlineShop() {
            if (!this.shops) return false
            const shop = this.shops.find(s => s.value === this.shop_id)
            return shop ? shop.is_online == 1 : false
        },
    },

    methods: {
        setToday() {
            this.value = moment().format("yyyy-MM-DD");
        },
        showEvent({ event, nativeEvent }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                setTimeout(() => (this.selectedOpen = true), 10);
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                setTimeout(open, 10);
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        toMonth() {
            this.type = "month";
            this.prev = '前月'
            this.next = '次月'
        },
        toDay({ date }) {
            this.value = date;
            this.type = "category"
            this.prev = '前日'
            this.next = '次日'
        },
        async getShopId() {
            if (this.shops == null) {
                await this.$axios.get(`/api/v1/shop`)
                    .then(response => {
                        this.shops = response.data.shops;
                    })
                const shop_id = this.$store.state.user.shop_id || this.shops[0].value;
                this.shop_id = shop_id;
            }
            return this.shop_id;
        },
        async getEvents({ start, end }) {
            this.now = { start, end };
            const shop_id = await this.getShopId();
            const query = this.type == 'month' ? `start=${start.date}&end=${end.date}` : `t=${this.value}`;
            let uri = `/api/v1/calendar?${query}&shop_id=${shop_id}`

            const kinds = this.filter()
            if (kinds.length > 0) {
                uri = uri + '&' + kinds;
            }

            await this.$axios.get(uri)
                .then(response => {
                    this.events = response.data.events.map(e => {
                        const counselor = response.data.counselors.find(c => c.id == e.counselor_id);
                        const counselorMaster = this.counselorMasters.find(c => c.id == e.counselor_id);
                        e.category = counselor ? counselor.name : (counselorMaster ? counselorMaster.name : "担当無し");
                        return e;
                    });
                    this.countBlindDate = response.data.countBlindDate.map(c => {
                        return {
                            name: c.name,
                            type: c.type,
                            '1': c.schedule,
                            '2': c.implementation,
                            '3': c.total + '(' + c.failure + ')',
                        }
                    });
                    this.counselors = response.data.counselors.map(c => c.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        changeShop() {
            this.getEvents(this.now);
            this.boothNos = this.boothNoMasters.filter((item) => {
                return item.shop_id == this.shop_id
            });
            this.getCO(this.shop_id)
        },
        getEventColor(event) {
            return event.color;
        },
        getMonth() {
            return moment(this.value).format("MM")
        },
        filter() {
            let filter = []

            if (this.filter_kind.all) {
                filter = []
                return filter.map(kind => `filter_kind[]=${kind}`).join('&')
            }
            if (this.filter_kind.matching || this.filter_kind.all) {
                filter = [...filter, 'お見合い']
            }

            if (this.filter_kind.counseling || this.filter_kind.all) {
                filter = [...filter, 'カウンセリング']
            }

            if (this.filter_kind.own_schedule || this.filter_kind.all) {
                filter = [...filter, '自分予定のみ']
            }

            return filter.map(kind => `filter_kind[]=${kind}`).join('&')
        },
        getBoothNo() {
            this.$axios
                .get("/api/v1/booth_no")
                .then((response) => {
                    this.boothNoMasters = response.data.booth_nos
                    this.boothNos = this.boothNoMasters.filter((item) => {
                        return item.shop_id == this.shop_id
                    });
                })
                .catch((error) => {
                    console.log("Error : " + error);
                });
        },
        getCO(shop_id) {
            const shopIdToGetAllCounselor = 0
            let tmp_shop_id = store.state.user.shop_id;
            if (tmp_shop_id === 0) {
                tmp_shop_id = 1
            }
            if (shop_id) {
                tmp_shop_id = shop_id;
            }
            this.$axios
                .get(`/api/v1/user/counselors?shop_id=${shopIdToGetAllCounselor}`)
                .then((response) => {
                    this.counselorMasters = response.data.counselors
                    const shop = this.shops ? this.shops.find(s => s.value === tmp_shop_id) : null
                    if (shop && shop.is_online == 1) {
                        this.counselorsForForm = this.counselorMasters
                    } else {
                        this.counselorsForForm = this.counselorMasters.filter(counselor => counselor.shop_id === tmp_shop_id)
                    }
                })
                .catch((error) => {
                    console.log("Error : " + error)
                })
        },
        refreshCalendar() {
            this.getEvents(this.now)
        },
        closeMenu() {
            this.$refs.pCloseMenu.click()
        },
        getEventKindName(event) {
            // 連盟見合（CS_MATCHING）の場合、connect_flagに基づいて区分を表示
            if (event.kind === this.CUSTOMER.EXEC_KIND.VAL.CS_MATCHING && event.connect_flag) {
                const flagName = this.CUSTOMER.CONNECT_FLAG.getName(event.connect_flag);
                // connect_flagの名称が取得できない場合はデフォルト名にフォールバック
                return flagName || this.CUSTOMER.EXEC_KIND.getName(event.kind);
            }
            return this.CUSTOMER.EXEC_KIND.getName(event.kind);
        },

    },
};
</script>

<style scoped>
.items {
    position: absolute;
    top: 12px;
    left: 12px;
}

.v-size--x-small {
    min-width: 20px !important;
    font-size: 1rem;
}
.table-count {
    width: 25vw;
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center;
}
.info-search {
    margin: 1% 0;
}
@media screen and (max-width: 1800px) {
    .table-count {
        margin-right: 30px;
    }
}
</style>
